import { FC, useState } from 'react'
import { SiteModel } from '../../../core/_models'
import { formatTRY } from '_metronic/partials/widgets/tables/TenderListWidget'
type Props = {
  site: SiteModel
}
const EstimatedProcurementCostTry: FC<Props> = ({ site }) => {

  return (
    <div className='d-flex align-items-center'>
      {site.estimatedProcurementCostTRY != null && site.estimatedProcurementCostTRY != undefined && formatTRY(site.estimatedProcurementCostTRY.toFixed(2))}
    </div>
  )
}
export { EstimatedProcurementCostTry }
